var DateCountdown = function ($elem) {
	this.elem = $elem;
	this.$d = this.$h = this.$m = this.$s = null;
	this.interval = null;
	this.reloadAfterEnd = this.elem.data('reload');

	this.dateString = this.elem.data('date');
	this.date = moment(this.dateString);

	this.run = function () {
		if (this.elem.data('init')) {
			this.initContent();
		}

		this.$d = this.elem.find('[data-segment="d"]');
		this.$h = this.elem.find('[data-segment="h"]');
		this.$m = this.elem.find('[data-segment="m"]');
		this.$s = this.elem.find('[data-segment="s"]');

		this.tickTack();
		this.elem.show();
		this.runTimer();
	};

	this.initContent = function () {
		const attr = this.elem[0].getAttribute('data-segment-text');
		const segmentText = attr ? attr : 'д,ч,м,сек';
		const segmentArr = segmentText.split(',');
		let paramsText = {
			d: segmentArr[0],
			h: segmentArr[1],
			m: segmentArr[2],
			s: segmentArr[3],
		};

		this.elem.html(
			`<span data-segment="d" data-after="${paramsText.d}"></span>
			<span data-segment="h" data-after="${paramsText.h}"></span>
			<span data-segment="m" data-after="${paramsText.m}"></span>
			<span data-segment="s" data-after="${paramsText.s}"></span>`
		);
	};

	this.runTimer = function () {
		var self = this;

		this.interval = setInterval(function () {
			self.tickTack()
		}, 1000);
	};

	this.tickTack = function () {
		var curDate = moment();
		if (curDate > this.date) {
			clearInterval(this.interval);
			return false;
		}

		var distance = this.date - curDate;

		var days = Math.floor(distance / (1000 * 60 * 60 * 24));
		var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		var seconds = Math.floor((distance % (1000 * 60)) / 1000);

		if (distance < 0) {
			clearInterval(this.interval);
			if (this.reloadAfterEnd) {
				location.reload()
			}
			return false;
		}

		this.print(days, hours, minutes, seconds);
	};

	this.print = function (d, h, m, s) {
		this.$d.text(d);
		this.$h.text(h);
		this.$m.text(m);
		this.$s.text(s);

		if (!d) this.$d.hide();
		if (!d && !h) this.$h.hide();
	}
};

$(document).ready(function () {
	$('[data-datetime-counter]').each(function () {
		new DateCountdown($(this)).run();
	});
});